// tslint:disable
export enum DocumentGroupStatus {
    /**
     * @description UNPROCESSED
     */
    UNKN = 0,
    /**
     * @description LOADED
     */
    LOAD = 1,
    /**
     * @description PENDING
     */
    PEND = 2,
    /**
     * @description MISSING INFORMATION
     */
    MISSINFO = 3,
    /**
     * @description PROCESSED
     */
    PRCSED = 4,
    /**
     * @description UN ASSIGNED
     */
    UNASGN = 5,
    /**
     * @description NOT READABLE
     */
    NOTRD = 6,
    /**
     * @description SKIPPED
     */
    SKIP = 7,
    /**
     * @description EXPIRED
     */
    EXP = 8,
}
